var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionsSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#E8F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7924 32.7631C20.2651 32.7631 21.4589 31.5693 21.4589 30.0966C21.4589 28.624 20.2651 27.4302 18.7924 27.4302C17.3198 27.4302 16.126 28.624 16.126 30.0966C16.126 31.5693 17.3198 32.7631 18.7924 32.7631Z",
    fill: "#4B9BF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3351 27.4044C25.8553 27.2588 24.5377 28.3403 24.392 29.8201C24.2464 31.2999 25.328 32.6176 26.8078 32.7632C26.9831 32.7804 27.1598 32.7804 27.3351 32.7632C28.815 32.6176 29.8965 31.2999 29.7509 29.8201C29.6251 28.5416 28.6136 27.5302 27.3351 27.4044Z",
    fill: "#4B9BF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8236 17.2562C32.6912 17.0578 32.4667 16.9407 32.2282 16.9455H29.277V16.8938C29.2772 13.7626 26.739 11.2241 23.6078 11.2239C20.4767 11.2237 17.9382 13.7618 17.938 16.893C17.938 16.8933 17.938 16.8935 17.938 16.8938V16.9455H15.7375L14.9868 13.5283C14.9034 13.1807 14.5935 12.9349 14.236 12.9329H11V14.4862H13.6147L16.0223 25.5404C16.0858 25.9038 16.4041 26.1672 16.773 26.1617H30.3125C30.67 26.1596 30.9798 25.9139 31.0632 25.5663L32.979 17.9034C33.0351 17.6752 32.9772 17.434 32.8236 17.2562ZM23.6075 21.01C21.3342 21.01 19.4913 19.1671 19.4913 16.8938C19.4913 14.6205 21.3342 12.7776 23.6075 12.7776C25.8808 12.7776 27.7237 14.6205 27.7237 16.8938C27.7096 19.1612 25.8749 20.9958 23.6075 21.01Z",
    fill: "#4B9BF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9862 16.9715L21.5624 15.5218L20.4492 16.6091L22.4167 18.6024C22.5601 18.7488 22.7555 18.8325 22.9604 18.8354C23.1626 18.8453 23.3597 18.7703 23.504 18.6283L26.7659 15.5476L25.7045 14.4086L22.9862 16.9715Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionsSectionIcon);
export default __webpack_public_path__ + "static/media/subscriptions-section-icon.e00b1e404f1cebe2133bcdc8fc753a05.svg";
export { ForwardRef as ReactComponent };